module.exports = __webpack_public_path__ + "static/media/exclaimation-mark.6428e7ea.svg";